<template>
<WindowForAlert :id="'addPerson'" :title="title" :size="'m'" ref="addPerson">
	<related-person class="w100pct mc" @Update="updatePersonList" ref="AddPerson" :isMinHeight="true"></related-person>
	<button slot="btmBtn" class="functionBtn close" @click="_ConfirmAdd()" :disable="disable" :title="$t('cmd12',['确定'])" type="button">{{$t('cmd12',['确定'])}}</button>
</WindowForAlert>
</template>
<script>
import { mapGetters,mapActions,mapMutations } from 'vuex'
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue'
import RelatedPerson from "@/view/maintain/light/plant/part/RelatedPerson"

import {apiAddPerson} from "@/api/maintain/plant/list.js";
import * as lib from "@/util/lib.js";
import {getLanguageStr} from "@/util/language.js";
export default {
	components:{WindowForAlert,RelatedPerson},
	data(){
		return{
			PersonList:[],
			personId:[],
			title:'',
			disable:true
		}
	},
	computed:{
		...mapGetters({
			currentIndex:'stationDetail/currentIndex',
			btnGroup:'stationDetail/btnGroup'
		})
	},
	watch:{
		PersonList(val){
		   if(val.length>0){
			   this.disable=false
		   }else{
			   this.disable=true
		   }
		}
	},
	methods:{
		getLanguageStr,
		//打开
		show(obj){
			this.$refs.AddPerson.reset() 
			if(obj.title=='batch'){
				this.title=getLanguageStr("manage365","批量添加关联人")
			}else{
				this.title=getLanguageStr("crm38","添加关联人")
			}
			this.personId=obj.personId;
			this.$refs.addPerson.show({title:this.title});
		},
		//确认添加
		_ConfirmAdd( ){
			let request={
				stationIds:this.personId,
				watcherIds :this.PersonList
			}
			apiAddPerson(request).then(response=>{
				this.$refs.AddPerson.reset()
				this.$emit('refresh')
				this.$emit('clearSelect')
				if(this.btnGroup[this.currentIndex].Perms=='A/D/A'){
				// if(this.currentIndex==2){
					this.$emit('refreshPersonList')
				}
			},error=>{
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		//添加关联人
		updatePersonList(list){
		   this.PersonList=list
		},
	}
}
</script>




// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/AddPerson.vue